import { Component } from '@angular/core';

@Component({
  selector: 'app-docuvirtex',
  templateUrl: './docuvirtex.component.html',
  styleUrls: ['./docuvirtex.component.css']
})
export class DocuvirtexComponent {

}
